<template>
    <BaseButton theme="neutral" size="sm" class="w-full flex items-center justify-center gap-2" :aria-pressed="isPrioritized" :disabled="disabled" @click="emit('click')">
        <i class="bi text-base leading-none" :class="isPrioritized ? 'bi-star-fill' : 'bi-star'" aria-hidden="true"></i>
        {{ isPrioritized ? (prioritizedText ?? t("journeys.goalPriorityToggle.remove")) : (unprioritizedText ?? t("journeys.goalPriorityToggle.make")) }}
    </BaseButton>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import { useI18n } from "vue-i18n";

const {
    isPrioritized = false,
    prioritizedText,
    unprioritizedText,
    disabled = false,
} = defineProps<{
    isPrioritized?: boolean;
    prioritizedText?: string;
    unprioritizedText?: string;
    disabled?: boolean;
}>();

const { t } = useI18n();

const emit = defineEmits<{ click: [] }>();
</script>
